module.exports = __webpack_public_path__ + "img/loading-pacman.ffa58052.gif";